import React from "react";

function KYCPopUp(props) {
    return (
        <>
            <div className="container my-5 mx-auto px-2 md:px-5">
                <div className="w-full mt-8 mx-auto">
                    <p className="openSans-Light text-black mt-3 mb-3 text-xl md:text-2xl">
                        I accept and confirm that the aforesaid account is
                    </p>
                    <div className="openSans-Reg text-black text-sm md:text-base">
                        <ol className="list-inside lower-roman">
                            <li>fully KYC complaint;</li>
                            <li>
                                a regular bank account and not a small account;
                                and
                            </li>
                            <li>
                                periodic KYC with the said bank has been fully
                                updated as on date in accordance with the RBI
                                regulations and continues so as on date.
                            </li>
                        </ol>
                    </div>
                </div>
                <div className="w-full  my-8 text-center">
                    <button
                        className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4 transition-all"
                        title="Ok"
                        onClick={(e) => props.onclickhandler(e)}
                    >
                        Ok
                    </button>
                </div>
            </div>
        </>
    );
}

export default KYCPopUp;
